var text_field_default = {
  "root": "KTB9z",
  "text": "iE9J4",
  "input": "R6F-G",
  "small": "PyTb3",
  "medium": "t1OdA",
  "large": "GGUg1",
  "webview": "nGNBz",
  "endAdornment": "BpD70",
  "shown": "aRFJG",
  "value": "vDocn",
  "spinner": "r8Vr8",
  "spin": "sgz8k"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
